import { Expose, Type } from 'class-transformer';

export class CheckType {
  public code: string;

  @Expose({name: 'resultFieldsList'})
  @Type(() => CheckResultField)
  public resultFields: CheckResultField[];
}

export enum CheckResultSeverity {
  NONE = 'NONE',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR'
}

export class CheckResultField {
  public fieldCode: string;

  @Expose({name: 'valuesList'})
  @Type(() => CheckResultValue)
  public values: CheckResultValue[];
}

export class CheckResultValue {
  public value: string;
  public severity: CheckResultSeverity;
}

export type CheckDpe = { climateLabel: string; powerLabel: string; };

/**
 * Type guard narrowing a Check result value to a DPE result.
 * @param value Check result value to check, as produced by the 'result' column's valueGetter.
 * @return True if the value is a CheckDpe (has both a climateLabel and a powerLabel), false otherwise.
 */
export function isCheckDpe(value: unknown): value is CheckDpe {
  return typeof value === 'object' && value !== null && 'climateLabel' in value && 'powerLabel' in value;
}
